<template lang="pug">
  div
    h4 <kbd>區間速率報表</kbd>
    <h4>
      //-<input type="checkbox" v-model="isMerge"  v-if="department=='Admin'">
      //-<span class="text-danger"><strong>是否整合南北向數據報表</strong></span> &nbsp &nbsp &nbsp
      <span class="text-info"><strong>明細報表輸出類型</strong></span>
      <input type="radio" id="radio1" name="radios" value="illegalCar" checked v-model="radioValue">
        <label for="radio1">違規車輛</label>
      <input type="radio" id="radio2" name="radios"value="legalCar" v-model="radioValue">
        <label for="radio2">未違規車輛</label>
      <input type="radio" id="radio3" name="radios" value="allCar" v-model="radioValue">
        <label for="radio3">全部車輛</label> 
    </h4>
    hr
    div.custom-functions-wrapper
      div.custom-function(v-for="func in reportFunctions")
        h5  {{ func.name }}
        hr
        QueryFilter(
          :showDate="func.query_by_date"
          :showEventType="false" 
          :showSystem="false" 
          :showFilterButton="false"
          v-on:report="report($event, func.function_name, func.name, func.query_by_date)")
</template>

<script>
import FileSaver from 'file-saver';
import { webSocketServer } from '@/config';
import QueryFilter from './QueryFilter';
import axios from 'axios';

export default {
  name: 'CustomReport',
  components: {
    QueryFilter,
  },
  data() {
    return {
      reportFunctions: [],
      downloadProgress: undefined,
      department: this.$store.state.user.user.department.name,
      isMerge: false,
      radioValue: 'illegalCar',
    };
  },
  computed: {
    instance() {
      return this.$store.getters.instance;
    },
  },
  methods: {
    dateFilled(emitPayload) {
      if ((emitPayload.start_date === undefined || emitPayload.start_date === '') || (emitPayload.end_date === undefined || emitPayload.end_date === '')) {
        return false;
      }
      return true;
    },
    getReportFunctions() {
      this.reportFunctions = [];
      this.instance.get('/api/report-functions/')
      .then((res) => {
        res.data.forEach((item) => {
          if (item.function_name.search("car") !== -1 && item.on_status) {
            this.reportFunctions.push(item);
          }
        });
      });
    },
    connectWebSocket(filename) {
      return new Promise((resolve, rejects) => {
        const wb = new WebSocket(`${webSocketServer}/download-report/${this.$store.state.user.user.id}`);
        wb.onopen = () => {
          this.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = (res) => {
          const data = JSON.parse(res.data);
          if (data.error) {
            this.$store.commit('CLOSE_MESSAGE');
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error,
            });
          }

          if (data.progress !== undefined) {
            this.downloadProgress = parseFloat(data.progress);
          }
          if (data.download_path !== undefined) {
            //this.instance.get(data.download_path, { responseType: 'blob' })
            //20200807 add
            axios.get(data.download_path, { responseType: 'blob' })
            .then((res) => {
              FileSaver.saveAs(res.data, `${filename}.xlsx`);
              this.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功',
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = () => { rejects(wb); };
      });
    },
    downloadReport(params, functionName, FileName) {
      params.function_name = functionName;
      this.connectWebSocket(FileName).then((wb) => {
        wb.send(JSON.stringify(params));
      })
      .catch((wb) => {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        wb.close();
      });
    },
    // downloadReport(emitPayload, functionName, FileName) {
    //   this.$store.commit('SET_MESSAGE', {
    //     type: 'warn',
    //     context: '下載中...',
    //   });
    //   emitPayload.function_name = functionName;
    //   this.instance.get('/export-report/', {
    //     params: emitPayload,
    //     responseType: 'blob',
    //   })
    //   .then((res) => {
    //     console.log('download success');
    //     FileSaver.saveAs(res.data, `AUTOIX-${FileName}.xlsx`);
    //     this.$store.commit('CLOSE_MESSAGE');
    //   })
    //   .catch((err) => {
    //     const reader = new FileReader();
    //     reader.addEventListener('loadend', (e) => {
    //       const eventCount = parseInt(e.srcElement.result, 10);
    //       if (eventCount > 0) {
    //         this.$store.commit('SET_MESSAGE', {
    //           type: 'error',
    //           context: '範圍資料過多，請縮小範圍',
    //         });
    //       }
    //       if (eventCount === 0) {
    //         this.$store.commit('SET_MESSAGE', {
    //           type: 'error',
    //           context: '範圍內無資料',
    //         });
    //       }
    //     });
    //     reader.readAsText(err.response.data);
    //   });
    // },
    report(emitPayload, functionName, FileName, useDate) {
      emitPayload.detailType= this.radioValue;
      if(this.isMerge==false) {
        emitPayload.fixed_link_code_id = this.$store.state.user.user.department.fixed_link_code;
      }
      else {
        emitPayload.fixed_link_code_id = '';    
      }
      if (useDate) {
        if (this.dateFilled(emitPayload) === false) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '請確定已選填日期',
          });
        } else {
          this.downloadReport(emitPayload, functionName, FileName);
        }
      } else {
        this.downloadReport(emitPayload, functionName, FileName);
      }
    },
  },
  created() {
    this.getReportFunctions();
  },
  watch: {
    radioValue(val) {
      this.radioValue = val;
      console.log(this.radioValue);
    },
    downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: `
        <h6>產生報告中</h6>
        <div class="progress">
          <div class="progress-bar progress-bar-striped" 
            role="progressbar" 
            style="width: ${val}%; background-color: #117a8b" 
            aria-valuenow="${val}" 
            aria-valuemin="0" 
            aria-valuemax="100">
          </div>
        </div>
        `,
        type: 'clean',
        confirm: false,
      });
    },
  },
};
</script>

<style lang="sass">
.custom-function
  width: 300px
  margin: 10px 10px
  display: inline-block

input[type=radio]
  display: none;

input[type=radio]+label
  display: inline-block;
  margin: -2px;
  padding: 4px 12px;
  margin-bottom: 0;
  font-size: 20px;
  line-height: 20px;
  color: #333;
  text-align: center;
  text-shadow: 0 1px 1px rgba(255,255,255,0.75);
  vertical-align: middle;
  cursor: pointer;
  background-color: #f5f5f5;
  background-image: -moz-linear-gradient(top,#fff,#e6e6e6);
  background-image: -webkit-gradient(linear,0 0,0 100%,from(#fff),to(#e6e6e6));
  background-image: -webkit-linear-gradient(top,#fff,#e6e6e6);
  background-image: -o-linear-gradient(top,#fff,#e6e6e6);
  background-image: linear-gradient(to bottom,#fff,#e6e6e6);
  background-repeat: repeat-x;
  border: 1px solid #ccc;
  border-color: #e6e6e6 #e6e6e6 #bfbfbf;
  border-color: rgba(0,0,0,0.1) rgba(0,0,0,0.1) rgba(0,0,0,0.25);
  border-bottom-color: #b3b3b3;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff',endColorstr='#ffe6e6e6',GradientType=0);
  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
  -webkit-box-shadow: inset 0 2px 4px rgba(0,0,0,0.15),0 1px 2px rgba(0,0,0,0.05);
  -moz-box-shadow: inset 0 2px 4px rgba(0,0,0,0.15),0 1px 2px rgba(0,0,0,0.05);
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.2),0 1px 2px rgba(0,0,0,0.05);

input[type=radio]:checked+label
  background-image: none;
  outline: 0;
  -webkit-box-shadow: inset 0 2px 4px rgba(0,0,0,0.15),0 1px 2px rgba(0,0,0,0.05);
  -moz-box-shadow: inset 0 2px 4px rgba(0,0,0,0.15),0 1px 2px rgba(0,0,0,0.05);
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.15),0 1px 2px rgba(0,0,0,0.05);
  background-color: #e0e0e0;

</style>



// WEBPACK FOOTER //
// CustomReport.vue?b57e8db8